/**
 * Impl dos use cases do workflow admin de Protocolo (acadadmin).
 *
 * @since G.5.16
 */
import type {
  Protocolo, ProtocoloMensagem, ProtocoloTransferencia, ProtocoloAnexo,
  AbrirProtocoloCommand, ResponderProtocoloCommand,
  EncerrarProtocoloCommand, TransferirProtocoloCommand,
} from '@/domain/model/Protocolo';
import type { ProtocoloWorkflowGateway } from '@/application/port/out/ProtocoloWorkflowGateway';
import type {
  GetProtocoloUseCase, ListProtocoloThreadUseCase, ListProtocoloTransferenciasUseCase,
  AbrirProtocoloUseCase, ResponderProtocoloUseCase, EncerrarProtocoloUseCase,
  ReabrirProtocoloUseCase, TransferirProtocoloUseCase,
  ListProtocoloAnexosUseCase, UploadProtocoloAnexoUseCase,
} from '@/application/port/in/ProtocoloWorkflowUseCase';

export class GetProtocolo implements GetProtocoloUseCase {
  constructor(private readonly g: ProtocoloWorkflowGateway) {}
  execute(id: string): Promise<Protocolo> { return this.g.get(id); }
}
export class ListProtocoloThread implements ListProtocoloThreadUseCase {
  constructor(private readonly g: ProtocoloWorkflowGateway) {}
  execute(id: string): Promise<ProtocoloMensagem[]> { return this.g.thread(id); }
}
export class ListProtocoloTransferencias implements ListProtocoloTransferenciasUseCase {
  constructor(private readonly g: ProtocoloWorkflowGateway) {}
  execute(id: string): Promise<ProtocoloTransferencia[]> { return this.g.transferencias(id); }
}
export class AbrirProtocolo implements AbrirProtocoloUseCase {
  constructor(private readonly g: ProtocoloWorkflowGateway) {}
  execute(cmd: AbrirProtocoloCommand): Promise<Protocolo> { return this.g.abrir(cmd); }
}
export class ResponderProtocolo implements ResponderProtocoloUseCase {
  constructor(private readonly g: ProtocoloWorkflowGateway) {}
  execute(id: string, cmd: ResponderProtocoloCommand): Promise<Protocolo> { return this.g.responder(id, cmd); }
}
export class EncerrarProtocolo implements EncerrarProtocoloUseCase {
  constructor(private readonly g: ProtocoloWorkflowGateway) {}
  execute(id: string, cmd: EncerrarProtocoloCommand): Promise<Protocolo> { return this.g.encerrar(id, cmd); }
}
export class ReabrirProtocolo implements ReabrirProtocoloUseCase {
  constructor(private readonly g: ProtocoloWorkflowGateway) {}
  execute(id: string): Promise<Protocolo> { return this.g.reabrir(id); }
}
export class TransferirProtocolo implements TransferirProtocoloUseCase {
  constructor(private readonly g: ProtocoloWorkflowGateway) {}
  execute(id: string, cmd: TransferirProtocoloCommand): Promise<Protocolo> { return this.g.transferir(id, cmd); }
}
export class ListProtocoloAnexos implements ListProtocoloAnexosUseCase {
  constructor(private readonly g: ProtocoloWorkflowGateway) {}
  execute(mensagemId: string): Promise<ProtocoloAnexo[]> { return this.g.listAnexos(mensagemId); }
}
export class UploadProtocoloAnexo implements UploadProtocoloAnexoUseCase {
  constructor(private readonly g: ProtocoloWorkflowGateway) {}
  execute(mensagemId: string, file: File): Promise<ProtocoloAnexo> { return this.g.uploadAnexo(mensagemId, file); }
}
